<template>
  <v-container id=container fluid>
    <v-row no-gutters align-content="center">
      <v-col>
        <MenuItem title='About' :img_src="require('@/assets/menu_about.png')" dialog_width="auto">
          <About/>
        </MenuItem>
      </v-col>
      <v-col>
        <MenuItem title='Concept' :img_src="require('@/assets/menu_concept.png')" dialog_width="auto">
          <Concept/>
        </MenuItem>
      </v-col>
      <v-col>
        <MenuItem title='Audience' :img_src="require('@/assets/menu_audience.png')" dialog_width="auto">
          <Audience/>
        </MenuItem>
      </v-col>
      <v-col>
        <MenuItem title='Terms of Service利用規約' :img_src="require('@/assets/menu_tos.png')" dialog_width="800px">
          <Terms/>
        </MenuItem>
      </v-col>
      <v-col>
        <button @click="logout">
          <img id="button-img" src="@/assets/menu_logout.png" alt="Logout" />
        </button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MenuItem from '@/components/MenuItem'
import About from '@/components/About'
import Concept from '@/components/Concept'
import Audience from '@/components/Audience'
import Terms from '@/components/Terms'

export default {
  name: 'MenuBar',
  components: {MenuItem, Terms, About, Concept, Audience},
  data: function() {
    return {
      showHello: true
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    },
  },
}
</script>

<style scoped>
#container {
  background: black;
  margin: 0;
  width: 100%;
  padding: 0;
  height: auto
}
#menubar {
  height: 300px;
}

p.next-indent {
  margin-bottom: 0;
}

p.next-indent + p {
  text-indent: 4em;
}

button {
  outline: none;
}

#button-img {
  width:100%;
  max-width: 300px;
}
</style>
